import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-anchor', 'top', 'Scroll to the top of the page');
Labels.set('ui-anchor', 'bottom', 'Scroll to the bottom of the page');
Labels.set('ui-anchor', 'left', 'Scroll to the left');
Labels.set('ui-anchor', 'right', 'Scroll to the right');
